/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ComplianceBlastRadiusResponse,
  KevBlastRadiusResponse,
  VulnerabilityBlastRadiusResponse,
} from '../models/index';
import {
    ComplianceBlastRadiusResponseFromJSON,
    ComplianceBlastRadiusResponseToJSON,
    KevBlastRadiusResponseFromJSON,
    KevBlastRadiusResponseToJSON,
    VulnerabilityBlastRadiusResponseFromJSON,
    VulnerabilityBlastRadiusResponseToJSON,
} from '../models/index';

export interface MdmComplianceBlastRadiusRequest {
    frameworkId: string;
    sessionId: string;
}

export interface MdmCveBlastRadiusRequest {
    cveId: string;
    sessionId: string;
    includePersonTraversal?: boolean;
    personWindowDays?: number;
    personMaxNodes?: number;
}

export interface MdmKevBlastRadiusRequest {
    sessionId: string;
}

/**
 * MDMVulnerabilityBlastRadiusApi - interface
 * 
 * @export
 * @interface MDMVulnerabilityBlastRadiusApiInterface
 */
export interface MDMVulnerabilityBlastRadiusApiInterface {
    /**
     * 
     * @summary Compliance framework blast-radius (REQ-VR-02)
     * @param {string} frameworkId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMVulnerabilityBlastRadiusApiInterface
     */
    mdmComplianceBlastRadiusRaw(requestParameters: MdmComplianceBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceBlastRadiusResponse>>;

    /**
     * Compliance framework blast-radius (REQ-VR-02)
     */
    mdmComplianceBlastRadius(requestParameters: MdmComplianceBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceBlastRadiusResponse>;

    /**
     * 
     * @summary CVE blast-radius (REQ-VR-01)
     * @param {string} cveId 
     * @param {string} sessionId 
     * @param {boolean} [includePersonTraversal] 
     * @param {number} [personWindowDays] 
     * @param {number} [personMaxNodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMVulnerabilityBlastRadiusApiInterface
     */
    mdmCveBlastRadiusRaw(requestParameters: MdmCveBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VulnerabilityBlastRadiusResponse>>;

    /**
     * CVE blast-radius (REQ-VR-01)
     */
    mdmCveBlastRadius(requestParameters: MdmCveBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VulnerabilityBlastRadiusResponse>;

    /**
     * 
     * @summary KEV blast-radius (REQ-VR-05)
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMVulnerabilityBlastRadiusApiInterface
     */
    mdmKevBlastRadiusRaw(requestParameters: MdmKevBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KevBlastRadiusResponse>>;

    /**
     * KEV blast-radius (REQ-VR-05)
     */
    mdmKevBlastRadius(requestParameters: MdmKevBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KevBlastRadiusResponse>;

}

/**
 * 
 */
export class MDMVulnerabilityBlastRadiusApi extends runtime.BaseAPI implements MDMVulnerabilityBlastRadiusApiInterface {

    /**
     * Compliance framework blast-radius (REQ-VR-02)
     */
    async mdmComplianceBlastRadiusRaw(requestParameters: MdmComplianceBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceBlastRadiusResponse>> {
        if (requestParameters['frameworkId'] == null) {
            throw new runtime.RequiredError(
                'frameworkId',
                'Required parameter "frameworkId" was null or undefined when calling mdmComplianceBlastRadius().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmComplianceBlastRadius().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/compliance/{frameworkId}/blast-radius`;
        urlPath = urlPath.replace(`{${"frameworkId"}}`, encodeURIComponent(String(requestParameters['frameworkId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComplianceBlastRadiusResponseFromJSON(jsonValue));
    }

    /**
     * Compliance framework blast-radius (REQ-VR-02)
     */
    async mdmComplianceBlastRadius(requestParameters: MdmComplianceBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceBlastRadiusResponse> {
        const response = await this.mdmComplianceBlastRadiusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * CVE blast-radius (REQ-VR-01)
     */
    async mdmCveBlastRadiusRaw(requestParameters: MdmCveBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VulnerabilityBlastRadiusResponse>> {
        if (requestParameters['cveId'] == null) {
            throw new runtime.RequiredError(
                'cveId',
                'Required parameter "cveId" was null or undefined when calling mdmCveBlastRadius().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmCveBlastRadius().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['includePersonTraversal'] != null) {
            queryParameters['includePersonTraversal'] = requestParameters['includePersonTraversal'];
        }

        if (requestParameters['personWindowDays'] != null) {
            queryParameters['personWindowDays'] = requestParameters['personWindowDays'];
        }

        if (requestParameters['personMaxNodes'] != null) {
            queryParameters['personMaxNodes'] = requestParameters['personMaxNodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/vulnerabilities/{cveId}/blast-radius`;
        urlPath = urlPath.replace(`{${"cveId"}}`, encodeURIComponent(String(requestParameters['cveId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VulnerabilityBlastRadiusResponseFromJSON(jsonValue));
    }

    /**
     * CVE blast-radius (REQ-VR-01)
     */
    async mdmCveBlastRadius(requestParameters: MdmCveBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VulnerabilityBlastRadiusResponse> {
        const response = await this.mdmCveBlastRadiusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * KEV blast-radius (REQ-VR-05)
     */
    async mdmKevBlastRadiusRaw(requestParameters: MdmKevBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KevBlastRadiusResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling mdmKevBlastRadius().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/vulnerabilities/kev/blast-radius`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KevBlastRadiusResponseFromJSON(jsonValue));
    }

    /**
     * KEV blast-radius (REQ-VR-05)
     */
    async mdmKevBlastRadius(requestParameters: MdmKevBlastRadiusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KevBlastRadiusResponse> {
        const response = await this.mdmKevBlastRadiusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
